module.exports = __webpack_public_path__ + "img/icon.4a4a7189.png";